import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

const cardStyle = {
  display: 'flex',
  position:"relative",
  flexDirection: 'column',
  alignItems: 'center',
  width: '250px',
  margin:"10px",
  transition: 'transform 0.2s, border 0.2s',
  borderRadius: '10px', // Add this line to set border radius
};

const cardMediaStyle = {
  height: '350px',
  width: '100%',
  position: 'relative',
  transition: 'transform 0.2s',
};

const titleStyle = {
  position: 'absolute',
  bottom: '0',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '100%',
  padding: '10px',
  background: 'rgba(0, 0, 0, 0.5)',
  color: 'white',
  textAlign: 'center',
  transition: 'background 0.2s, opacity 0.2s', // Added opacity transition
};

const hiddenTitleStyle = {
  opacity: 0, // Hidden text
};

const StylesCard = ({ image,image2, title,bottom}) => {
  const [isHovered, setHovered] = useState(false);

  return (
    <Card
      style={{
        ...cardStyle,
        transform: isHovered ? 'translateY(-10px)' : 'none',
        bottom: `${bottom}px`, // Use template literals to include the value of 'bottom'
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <CardMedia
        style={{ ...cardMediaStyle, transform: isHovered ? 'scale(1.1)' : 'none' }}
        image={isHovered ? image2 : image}
        title="Image Title"
      >
        <Typography variant="subtitle" style={isHovered ? hiddenTitleStyle : titleStyle}>
          {title}
        </Typography>
      </CardMedia>
    </Card>
  );
};

export default StylesCard;
